import React from 'react';
import clsx from 'clsx';
import { useForm } from 'react-hook-form';

import { Input } from '../form';
import Icons from '@/const/icons';
import { Avatar, Button, Typography } from '@/components/common';
import { Checkbox } from '../ui/checkbox';
import { LawyerItem } from '@/interfaces';

interface Props {
	listLawyers: LawyerItem[];
	currentLawyersSelected: LawyerItem[];
	handleSelection: (values: LawyerItem[]) => void;
}

export const ListLawyersComponent: React.FC<Props> = ({
	listLawyers,
	currentLawyersSelected,
	handleSelection,
}) => {
	const [lawyers, setLawyers] = React.useState<LawyerItem[]>(listLawyers);
	const [lawyersSelected, setLawyersSelected] = React.useState<LawyerItem[]>(
		[]
	);

	const { register } = useForm();

	React.useEffect(() => {
		setLawyersSelected(currentLawyersSelected);
	}, [currentLawyersSelected]);

	const handleSearch = (value: string): void => {
		const filteredClients = listLawyers.filter((lawyer) => {
			const username = `${lawyer.firstname} ${lawyer.lastname}`;
			return username.toLowerCase().includes(value.toLowerCase());
		});
		setLawyers(filteredClients);
	};

	const handleSelectLawyers = (lawyer: LawyerItem) => {
		const isSelected = lawyersSelected.some((l) => l.id === lawyer.id);

		if (isSelected) {
			const newList = lawyersSelected.filter((l) => l.id !== lawyer.id);
			setLawyersSelected(newList);
		} else {
			setLawyersSelected((prev) => [...prev, lawyer]);
		}
	};

	const isChecked = (lawyerId: string) =>
		lawyersSelected.some((l) => l.id === lawyerId);

	return (
		<div className="w-full h-[25rem] lg:h-[30rem]">
			<div className="absolute w-[90%] left-4 lg:left-10 top-[5rem]">
				<Input
					name="search"
					register={register}
					placeholder="Search"
					iconLeft={Icons.search}
					classNameIcon={'!top-[23%] !w-4 !h-4 text-opacity-black'}
					classNameInput="pl-9 !bg-gray-15 !h-[33px] !m-0 border-none"
					onChange={({ target }) => handleSearch(target.value)}
				/>
			</div>
			<ul className="">
				{lawyers.map((client, index) => (
					<li
						key={'case-inquire-' + index}
						className={clsx(
							'hover:bg-grey-5 p-4 text-left cursor-pointer',
							'hover:border hover:border-green-base active:border-none',
							'active:bg-green-secondary focus:bg-green-secondary',
							'flex items-center gap-2 border-b border-[#0D061614]'
						)}
						onClick={() => handleSelectLawyers(client)}
					>
						<Checkbox
							checked={isChecked(client.id)}
							className="size-6"
							classNameIcon="w-5 h-5 text-green-60"
						/>
						<Avatar
							photoUrl={client.profile_picture || ''}
							size="small"
							firstname={`${client.firstname}`}
							lastname={`${client.lastname}`}
						/>
						<Typography type="regular-14">{`${client.firstname} ${client.lastname}`}</Typography>
					</li>
				))}
			</ul>
			<Button
				type="button"
				decoration="primary"
				className="absolute right-5 bottom-5"
				size="medium"
				onClick={() => handleSelection(lawyersSelected)}
			>
				Add
			</Button>
		</div>
	);
};
